export default {
  api_r_user_module_totalEnergiesRisk_getModuleData: {
    path: 'm/total-energies-risk/get-module-data/',
  },
  api_r_user_module_totalEnergiesRisk_getPermissions: {
    path: 'm/total-energies-risk/get-permissions/',
  },
  api_r_user_module_totalEnergiesRisk_risk_list: {
    path: 'm/total-energies-risk/risk/list/',
  },
  api_r_user_module_totalEnergiesRisk_risk_level: {
    path: 'm/total-energies-risk/risk/level/',
  },
  api_r_user_module_totalEnergiesRisk_risk_generateFilterHexCode: {
    path: 'm/total-energies-risk/risk/generate-filter-hex-code/',
  },
  api_r_user_module_totalEnergiesRisk_risk_getFilters: {
    path: 'm/total-energies-risk/risk/get-filters/',
  },
  api_r_user_module_totalEnergiesRisk_risk_add: {
    path: 'm/total-energies-risk/risk/add/',
  },
  api_r_user_module_totalEnergiesRisk_risk_get: {
    path: 'm/total-energies-risk/risk/get/',
  },
  api_r_user_module_totalEnergiesRisk_risk_edit: {
    path: 'm/total-energies-risk/risk/edit/',
  },
  api_r_user_module_totalEnergiesRisk_risk_cancel: {
    path: 'm/total-energies-risk/risk/cancel/',
  },
  api_r_user_module_totalEnergiesRisk_risk_reactivate: {
    path: 'm/total-energies-risk/risk/reactivate/',
  },
  api_r_user_module_totalEnergiesRisk_risk_assessment_edit: {
    path: 'm/total-energies-risk/risk/assessment/edit/',
  },
  api_r_user_module_totalEnergiesRisk_risk_assessmentAssistantInherentImpact_edit: {
    path: 'm/total-energies-risk/risk/assessment-assistant-inherent-impact/edit/',
  },
  api_r_user_module_totalEnergiesRisk_control_list: {
    path: 'm/total-energies-risk/control/list/',
  },
  api_r_user_module_totalEnergiesRisk_control_level: {
    path: 'm/total-energies-risk/control/level/',
  },
  api_r_user_module_totalEnergiesRisk_control_generateFilterHexCode: {
    path: 'm/total-energies-risk/control/generate-filter-hex-code/',
  },
  api_r_user_module_totalEnergiesRisk_control_getFilters: {
    path: 'm/total-energies-risk/control/get-filters/',
  },
  api_r_user_module_totalEnergiesRisk_control_get: {
    path: 'm/total-energies-risk/control/get/',
  },
  api_r_user_module_totalEnergiesRisk_control_add: {
    path: 'm/total-energies-risk/control/add/',
  },
  api_r_user_module_totalEnergiesRisk_control_edit: {
    path: 'm/total-energies-risk/control/edit/',
  },
  api_r_user_module_totalEnergiesRisk_control_cancel_toggle: {
    path: 'm/total-energies-risk/control/cancel/toggle/',
  },
  api_r_user_module_totalEnergiesRisk_control_review_get: {
    path: 'm/total-energies-risk/control/review/get/',
  },
  api_r_user_module_totalEnergiesRisk_control_review_edit: {
    path: 'm/total-energies-risk/control/review/edit/',
  },
  api_r_user_module_totalEnergiesRisk_control_review_validate: {
    path: 'm/total-energies-risk/control/review/validate/',
  },
  api_r_user_module_totalEnergiesRisk_control_review_fileDownload: {
    path: 'm/total-energies-risk/control/review/file-download/',
  },
  api_r_user_module_totalEnergiesRisk_control_review_goToLinkedRisks: {
    path: 'm/total-energies-risk/control/review/go-to-linked-risks/',
  },
  api_r_user_module_totalEnergiesRisk_control_getResponsibles: {
    path: 'm/total-energies-risk/control/get-responsibles/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_list: {
    path: 'm/total-energies-risk/action-plan/list/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_level: {
    path: 'm/total-energies-risk/action-plan/level/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_generateFilterHexCode: {
    path: 'm/total-energies-risk/action-plan/generate-filter-hex-code/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_getFilters: {
    path: 'm/total-energies-risk/action-plan/get-filters/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_get: {
    path: 'm/total-energies-risk/action-plan/get/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_add: {
    path: 'm/total-energies-risk/action-plan/add/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_edit: {
    path: 'm/total-energies-risk/action-plan/edit/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_cancel_toggle: {
    path: 'm/total-energies-risk/action-plan/cancel/toggle/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_review_get: {
    path: 'm/total-energies-risk/action-plan/review/get/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_review_edit: {
    path: 'm/total-energies-risk/action-plan/review/edit/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_review_validate: {
    path: 'm/total-energies-risk/action-plan/review/validate/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_review_fileDownload: {
    path: 'm/total-energies-risk/action-plan/review/file-download/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_review_goToLinkedRisks: {
    path: 'm/total-energies-risk/action-plan/review/go-to-linked-risks/',
  },
  api_r_user_module_totalEnergiesRisk_getRisks: {
    path: 'm/total-energies-risk/get-risks/',
  },
  api_r_user_module_totalEnergiesRisk_getControls: {
    path: 'm/total-energies-risk/get-controls/',
  },
  api_r_user_module_totalEnergiesRisk_getActionPlans: {
    path: 'm/total-energies-risk/get-action-plans/',
  },
  api_r_user_module_totalEnergiesRisk_getProcesses: {
    path: 'm/total-energies-risk/get-processes/',
  },
  api_r_user_module_totalEnergiesRisk_getSubProcesses: {
    path: 'm/total-energies-risk/get-subprocesses/',
  },
  api_r_user_module_totalEnergiesRisk_risk_information_tab: {
    path: 'm/total-energies-risk/risk/information/tab/',
  },
  api_r_user_module_totalEnergiesRisk_risk_control_tab: {
    path: 'm/total-energies-risk/risk/control/tab/',
  },
  api_r_user_module_totalEnergiesRisk_risk_assessment_tab: {
    path: 'm/total-energies-risk/risk/assessment/tab/',
  },
  api_r_user_module_totalEnergiesRisk_risk_actionPlan_tab: {
    path: 'm/total-energies-risk/risk/action-plan/tab/',
  },
  api_r_user_module_totalEnergiesRisk_control_review_tab: {
    path: 'm/total-energies-risk/control/review/tab/',
  },
  api_r_user_module_totalEnergiesRisk_actionPlan_review_tab: {
    path: 'm/total-energies-risk/action-plan/review/tab/',
  },
  api_r_user_module_totalEnergiesRisk_getNavbarInfo: {
    path: 'm/total-energies-risk/get-navbar-info/',
  },
  api_r_user_module_totalEnergiesRisk_process_list: {
    path: 'm/total-energies-risk/process/list/',
  },
  api_r_user_module_totalEnergiesRisk_process_add: {
    path: 'm/total-energies-risk/process/add/',
  },
  api_r_user_module_totalEnergiesRisk_process_edit: {
    path: 'm/total-energies-risk/process/edit/',
  },
  api_r_user_module_totalEnergiesRisk_process_delete: {
    path: 'm/total-energies-risk/process/delete/',
  },
  api_r_user_module_totalEnergiesRisk_process_getResponsibles: {
    path: 'm/total-energies-risk/process/get-responsibles/',
  },
  api_r_user_module_totalEnergiesRisk_log_list: {
    path: 'm/total-energies-risk/log/list/',
  },

  api_r_user_module_totalEnergiesRiskReport_xlsx1: {
    path: 'm/total-energies-risk-report/xlsx1/',
  },
};
